import request from '@/utils/request'
export function getOrders(data) {
	return request({
		url: '/open/order/orders',
		method: 'get',
		data
	})
}

export function getOrderPrice(data) {
	return request({
		url: '/open/order/price',
		method: 'post',
		data
	})
}
export function createOrder(data) {
	return request({
		url: '/open/order/store',
		method: 'post',
		data
	})
}
export function orderStatus(data) {
	return request({
		url: '/open/order/show_order',
		method: 'post',
		data
	})
}

export function uploadFile(data) {
	return request({
		url: '/open/order/store',
		method: 'post',
		data
	})
}
